import { _ as _createClass, a as _classCallCheck } from '../createClass-DV1OmW3s.js';
import { _ as _defineProperty } from '../defineProperty-DmV7cVMj.js';

var LRUCacheNode = /*#__PURE__*/_createClass(function LRUCacheNode(key, value, next, prev) {
  _classCallCheck(this, LRUCacheNode);
  _defineProperty(this, "key", undefined);
  _defineProperty(this, "value", undefined);
  _defineProperty(this, "next", undefined);
  _defineProperty(this, "prev", undefined);
  this.key = key;
  this.value = value;
  this.next = next || null;
  this.prev = prev || null;
});

export { LRUCacheNode as default };
//# sourceMappingURL=index.js.map
